// @flow
import { makeIconStyle, makeLabelStyle, makeDraggableLabelStyle, makeLabelConnectorStyle } from '../style';

const SCALE = 0.8;

const iconCache = {};
const makeCarIcon = (color: string) => {
    if(iconCache[color]) {
        return iconCache[color];
    }
    else {
        const icon = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 13 24'%3E%3Cpath fill='${color ? encodeURIComponent(color) : '%23fff'}' d='M12.5,7.9c0.2,0,0.4-0.2,0.5-0.4v-4C13,3.2,12.8,3,12.5,3h-0.1c-0.1-0.6-0.5-1.2-1-1.5L9.8,0.4C9.4,0.1,8.9,0,8.4,0H4.6c-0.5,0-1,0.1-1.4,0.4L1.6,1.5C1.1,1.8,0.7,2.4,0.6,3H0.5C0.2,3,0,3.2,0,3.5v4c0.1,0.2,0.3,0.3,0.5,0.4v1.4v6.2V16C0.2,16,0,16.2,0,16.5v4C0,20.7,0.2,21,0.5,21h0.1c0.2,1.7,0.1,3,1.8,3h8.2c1.8,0,1.6-1.4,1.9-3h0.1c0.3,0,0.5-0.2,0.5-0.5v-4c0-0.3-0.2-0.5-0.5-0.5v-0.5V9.3V7.9z M3,5.5C3.1,5.2,3.5,5,3.8,5h5.4C9.5,5,9.8,5.2,10,5.5c0.2,0.3,0.2,0.7,0,1l-1,2C8.9,8.8,8.6,9,8.2,9H4.8C4.4,9,4.1,8.8,3.9,8.4l-1-2C2.8,6.1,2.8,5.8,3,5.5z M1.5,14.7v-6l1,1v4.5L1.5,14.7z M10.3,18.8c0,0-1.2,1.1-3.8,1.1s-3.8-1.1-3.8-1.1c-0.2-0.2-0.2-0.4-0.1-0.6l1-2C3.7,16,4,15.9,4.2,16c0,0,0.9,0.4,2.3,0.4c1.4,0,2.3-0.4,2.3-0.4C8.9,16,9,16,9.1,16c0.1,0,0.2,0.1,0.3,0.3l1,2C10.5,18.4,10.5,18.7,10.3,18.8zM11.5,14.7l-1-0.5V9.7l1-1V14.7z'/%3E%3C/svg%3E%0A`;
        iconCache[color] = icon;
        return icon;
    }

};

const systemStyle = {
    icon: makeIconStyle(makeCarIcon('#CC803D'), SCALE),
    label: makeLabelStyle('#FFFFFF', '#CC803D')
};
const deviceStyle = {
    icon: makeIconStyle(makeCarIcon('#853F00'), SCALE),
    label: makeLabelStyle('#ffffff', '#853F00')
};

const selectedSystemStyle = {
    icon: makeIconStyle(makeCarIcon('#805026'), SCALE * 1.2),
    label: makeLabelStyle('#FFFFFF', '#805026')
};
const selectedDeviceStyle = {
    icon: makeIconStyle(makeCarIcon('#805026'), SCALE * 1.2),
    label: makeLabelStyle('#ffffff', '#805026')
};

export const targetStyles = {
    default: {
        auto: systemStyle,
        system: systemStyle,
        device: deviceStyle
    },
    selected: {
        auto: selectedSystemStyle,
        system: selectedSystemStyle,
        device: selectedDeviceStyle
    }
};

const systemDraggableLabel = makeDraggableLabelStyle('#ffffff', '#CC803D');
const deviceDraggableLabel = makeDraggableLabelStyle('#ffffff', '#853F00');

export const draggableLabelStyles = {
    default: {
        auto: systemDraggableLabel,
        system: systemDraggableLabel,
        device: deviceDraggableLabel
    },
    selected: {
        auto: systemDraggableLabel,
        system: systemDraggableLabel,
        device: deviceDraggableLabel
    }
};

const systemLabelConnector = makeLabelConnectorStyle('#CC803D');
const deviceLabelConnector = makeLabelConnectorStyle('#853F00');
export const labelConnectorStyles = {
    default: {
        auto: systemLabelConnector,
        system: systemLabelConnector,
        device: deviceLabelConnector
    },
    selected: {
        auto: systemLabelConnector,
        system: systemLabelConnector,
        device: deviceLabelConnector
    }
};